'use client';

import { createContext, useContext, type ReactNode } from 'react';

/**
 * Self-hosted white-label instance facts the client UI needs (WL-5a), resolved once on
 * the server by the root layout from GET /v1/instance/runtime. On platform builds the
 * default value is used and nothing here changes behaviour.
 */
export interface InstanceInfo {
  /** Lease flag b2b.course_engine. Always true on platform builds. */
  courseEngineLicensed: boolean;
  /** Tenant suspended: the API is read-only (writes get 423). */
  readOnly: boolean;
}

export const PLATFORM_INSTANCE_INFO: InstanceInfo = { courseEngineLicensed: true, readOnly: false };

const InstanceContext = createContext<InstanceInfo>(PLATFORM_INSTANCE_INFO);

export function InstanceProvider({ value, children }: { value: InstanceInfo; children: ReactNode }) {
  return <InstanceContext.Provider value={value}>{children}</InstanceContext.Provider>;
}

export function useInstance(): InstanceInfo {
  return useContext(InstanceContext);
}
